import { render, staticRenderFns } from "./o4PrintPelletView.vue?vue&type=template&id=8889d630&scoped=true"
import script from "./o4PrintPelletView.vue?vue&type=script&lang=js"
export * from "./o4PrintPelletView.vue?vue&type=script&lang=js"
import style0 from "./o4PrintPelletView.vue?vue&type=style&index=0&id=8889d630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8889d630",
  null
  
)

export default component.exports